import type { BrandIconProps } from './brandIconTypes';

export default function WindowsIcon({ className, ...props }: BrandIconProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.63588 2.99976H2.99951V9.63612H9.63588V2.99976Z"
        fill="currentColor"
      />
      <path
        d="M16.9999 2.99976H10.3635V9.63612H16.9999V2.99976Z"
        fill="currentColor"
      />
      <path
        d="M9.63588 10.3645H2.99951V17.0009H9.63588V10.3645Z"
        fill="currentColor"
      />
      <path
        d="M16.9999 10.3645H10.3635V17.0009H16.9999V10.3645Z"
        fill="currentColor"
      />
    </svg>
  );
}
